export const paymentMethod = [
  { id: 1, value: 1, name: "信用卡" },
  { id: 2, value: 2, name: "ATM虛擬帳號" },
  { id: 3, value: 3, name: "Apple Pay" },
  { id: 4, value: 4, name: "Google Pay" },
  { id: 5, value: 5, name: "Samsung Pay" },
  { id: 6, value: 6, name: "Line Pay(不支援 一卡通(iPASS Money))" },
  { id: 7, value: 7, name: "Taiwan Pay" },
];

export const paymentMethodMap = paymentMethod.reduce((acc, cur) => {
  acc[cur.value] = cur;
  return acc;
}, {});
